// import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ResponseModel } from "../models/response.model";
import { DnnContextService } from "./Dnn/dnncontext.service";
import { ActualizacionModel } from "../models/actualizacion-datos.model";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AplicacionServices {
  public static HabilitarCargador:boolean = false;
  
  private _urlBase: string;
  private _headers: any;

  constructor(private http: HttpClient, private ctx: DnnContextService) {
    this._urlBase = this.ctx.properties.ModuleDirectory + 'API/Aplicacion/';
    this._headers = this.ctx.getServiceFramework();
  }

  async ValidarCuentaCliente(cuenta:string): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + 'ValidarCuentaCliente', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        },
        body: JSON.stringify(cuenta)
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async NuevaSolActualizacion(models:ActualizacionModel): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + 'NuevaSolActDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString(),
          'RequestVerificationToken': this._headers.antiForgeryToken
        },
        body: JSON.stringify(models)
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async ObtenerRegActDatos(): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + 'ObtenerRegActDatos', {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        }
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async ValidarAdmin(): Promise<ResponseModel>{
    try {
      var raw = await fetch(this._urlBase + 'ValidarAdmin', {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        }
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async ValidarToken(token:string): Promise<ResponseModel>{
    try {
      var raw = await fetch(this._urlBase + 'ValidarToken', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        },
        body: JSON.stringify(token)
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async ObtenerConstante(){
    return await (await fetch(this.ctx.properties.ModuleDirectory + 'wwwroot/assets/config/' + 'Constantes.json')).json();
  }

   async ObtenerTipoDoc(): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + `GetMaster?MultiTable=PRSTPD&AuxCode=0`, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        }
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

   async ObtenerTipoPer(): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + `GetMaster?MultiTable=PRSNAT&AuxCode=0`, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        }
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async ObtenerDeptos(): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + `GetMaster?MultiTable=DEPTOS&AuxCode=0`, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        }
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }

  async ObtenerMuni(depto:string): Promise<ResponseModel> {
    try {
      var raw = await fetch(this._urlBase + `GetMaster?MultiTable=V_MUNDANE&AuxCode=${depto}`, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'ModuleId' : this.ctx.properties.ModuleId.toString(),
          'TabId' : this._headers.tabId.toString()
        }
      });
      var res = raw.json();
      return res;
    }
    catch (err) {
      return new ResponseModel(false, 500, err);
    }
  }
  
}